<template>
  <div>
    <el-table
        ref="tableSurveyForm"
        element-loading-spinner="el-icon-loading"
        :data="dataTableSurveyForm"
        border
        :max-height="$tableMaxHeight"
        :header-cell-style="headerCellStyle"
        :element-loading-text="$tableLoading"
        @selection-change="handleSelectionChange"
        element-loading-background="rgba(255,255,255, 0)"
        v-loading="isLoading"
    >
      <el-table-column
          type="selection"
          width="50"
          align="center"
          fixed="left"
      />

      <el-table-column
          type="index"
          label="STT"
          width="50"
          align="center"
          fixed="left"
      />

      <el-table-column
          label="Ngày tạo"
          width="160"
          align="center"
          fixed="left"
      >
        <template v-slot:default="scope">
          <span>{{ scope.row.createdDate | formatDateTime }}</span>
        </template>
      </el-table-column>

      <el-table-column
          label="Mã phiếu"
          width="180"
          align="center"
          fixed="left"
      >
        <template v-slot:default="scope">
          <span style="text-transform: uppercase">{{ scope.row.codeForm }}</span>
        </template>
      </el-table-column>

      <el-table-column
          label="Tiêu đề"
          width="240"
          fixed="left"
      >
        <template v-slot:default="scope">
          <el-tooltip class="item" effect="dark" :content="`${scope.row.title}`" placement="top">
            <div class="see_more">{{ scope.row.title }}</div>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
          label="Ngày bắt đầu"
          width="140"
          align="center"
      >
        <template v-slot:default="scope">
          <span
              :style="[
                  {color: scope.row.fistDay ? '#F56C6C' : '#409EFF'}
                  ]"
          >
            {{ scope.row.fistDay ? scope.row.fistDay : "Không giới hạn" }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
          label="Ngày kết thúc"
          width="140"
          align="center"
      >
        <template v-slot:default="scope">
          <span
              :style="[
              {color: scope.row.lastDay ? '#F56C6C' : '#409EFF'}
              ]">
            {{ scope.row.lastDay ? scope.row.lastDay : "Không giới hạn" }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
          label="Mô tả"
          width="300"
      >
        <template v-slot:default="scope">
          <el-tooltip class="item" effect="dark" :content="`${scope.row.description}`" placement="top">
            <div class="see_more" style="white-space: pre-line">{{ scope.row.description }}</div>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
          label="Loại"
          width="140"
          align="center"
      >
        <template v-slot:default="scope">
          <span>{{ formatTypeCreatedForm(scope.row.typeCreate) }}</span>
        </template>
      </el-table-column>

      <el-table-column
          label="Tác vụ"
          width="360"
          align="center"
          fixed="right"
      >
        <template v-slot:default="scope">
          <div>
            <el-button @click="handleDetailForm(scope.row)" size="small" type="primary"
                       :disabled="scope.row.delActive === false">
              Chi tiết
            </el-button>

            <el-button @click="handleUpdateForm(scope.row.idForm, scope.row.answer)" size="small" type="success"
                       :disabled="scope.row.delActive === false" >
              Sửa
            </el-button>

            <el-button :disabled="getAppTypeUserLogin === scope.row.typeCreate" @click="deleteForm([scope.row.idForm])"
                       size="small" type="danger" v-if="scope.row.delActive" style="width:55px" >
              Ẩn
            </el-button>
            <el-button :disabled="getAppTypeUserLogin === scope.row.typeCreate" @click="restoreForm([scope.row.idForm])"
                       size="small" type="warning" v-if="!scope.row.delActive" >
              Hiện
            </el-button>

            <el-button @click="exportExcel(scope.row.idForm)" size="small" type="primary"
                       :disabled="scope.row.delActive === false">
              Thống kê
            </el-button>
          </div>
        </template>
      </el-table-column>

      <template #empty>
        <div style="text-align: center; font-size: 16px; color: #43a0ff;">
          <i class="el-icon-warning"></i>
          <span> Không có dữ liệu! </span>
        </div>
      </template>
    </el-table>

    <UpdateSurveyForm
        :is-open="isOpenDialog.update"
        @closeDialog="handleCloseUpdate"
        ref="updateSurveyForm"
    />

    <DetailSurveyForm
        :is-open="isOpenDialog.detail"
        @closeDialog="handleCloseDetail"
        ref="detailSurveyForm"
    />
  </div>
</template>

<script>


import SurveyForm from "@/services/SurveyForm";
import UpdateSurveyForm from "@/views/survey_form/dialog/UpdateSurveyForm.vue";
import DetailSurveyForm from "@/views/survey_form/dialog/DetailSurveyForm.vue";
import ExcelStatisticalSurveyForm from "@/services/ExcelStatisticalSurveyForm";


const headerCellStyle = () => {
  return {
    backgroundColor: "#78a5e7",
    color: "#fff",
  }
}
export default {
  components: {
    DetailSurveyForm,
    UpdateSurveyForm
  },
  props: {
    dataTableSurveyForm: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      isOpenDialog: {
        update: false,
        detail: false,
      },

      selectionMultiple: [],
      isTooltipVisible: {
        title: false,
      }
    }
  },

  methods: {
    headerCellStyle,
    formatTypeCreatedForm(type) {
      switch (type) {
        case "plus":
          return "Nhà trường";
        case "teacher":
          return "Giáo viên";
      }
    },

    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
    restoreForm(id){
      SurveyForm.restoreForm(id).then((res) => {
        this.$message({
          type: "success",
          message: res.data.message
        })
        this.handleResetData();
      }).catch((err) => {
        this.$message({
          type: "error",
          message: err.data.message
        })
      })

    },
    deleteForm(idList) {
      this.$confirm("Khi ẩn phụ huynh và nhân sự sẽ không thể sử dụng phiếu khảo sát này nữa. Bạn có chắc chắn muốn ẩn phiếu đã chọn?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(() => {
        SurveyForm.deleteFormById(idList).then((res) => {
          this.$message({
            type: "success",
            message: res.data.message
          })

          this.handleResetData();
        }).catch((err) => {
          this.$message({
            type: "error",
            message: err.data.message
          })
        })
      });
    },

    handleUpdateForm(id, answer) {
      this.isOpenDialog.update = true;
      this.$refs.updateSurveyForm.handleInitialData(id, answer);
    },

    handleResetData() {
      this.$emit("resetData");
    },

    handleCloseUpdate() {
      this.isOpenDialog.update = false;
      this.handleResetData();
    },

    handleDetailForm(row) {
      this.isOpenDialog.detail = true;
      this.$refs.detailSurveyForm.handleInitialData(row.idForm, row.typeCreate, row.idClass);
    },

    handleCloseDetail() {
      this.isOpenDialog.detail = false;
    },

    handleSelectionChange(value) {
      this.selectionMultiple = value;
    },

    handleMultipleRemove() {
      const dataMultiple = this.selectionMultiple;

      if (dataMultiple.length > 0) {
        const ids = [];

        dataMultiple.map((item) => {
          ids.push(item.idForm);
        })
        this.deleteForm(ids);
      } else {
        this.$message({
          type: "error",
          message: "Bạn chưa chọn phiếu khảo sát nào!"
        })
      }
    },

    exportExcel(id) {
      SurveyForm.exportExcelStatistical(id)
          .then(res => {
            const data = res.data.data;
            const headerSheet = data.excelHeadResponse;
            const questions = data.excelBodyResponse;
            const statistical = data.statisticalFormResponse;
            ExcelStatisticalSurveyForm.exportExcel(headerSheet, questions, statistical);
          })
          .catch(err => {
            console.log(err)
          })
    },
  }
}
</script>

<style lang="scss" scoped>
.see_more {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>